<script>

import MlssForm from './MlssForm';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { MlssForm },
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      search: '',
      dateRange: { startDate: null, endDate: null },

      status_list: [
        {value: '1', name: 'Live'},
        {value: '0', name: 'Not Live'},
        {value: '', name: 'Live & Not Live'},
      ],
      idx_types: [
        {id: 'rets', name: 'RETS', active: false},
        {id: 'bridge_api', name: 'Bridge API', active: false},
        {id: 'mls_grid', name: 'MLS Grid', active: false},
      ],
      back_office_types: [
        {id: 'rets', name: 'RETS', active: false},
        {id: 'bridge_api', name: 'Bridge API', active: false},
        {id: 'mls_grid', name: 'MLS Grid', active: false},
      ],

      default_new_mls: {
        status: 0,
        website: '',
        rets_property_types: [],
        rets_mapping: [],
        form_fields: [],
        zip_codes: [],
      },
      new_mls: {},

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        selects: [
'         id',
'         status',
'         user_id',
'         website',
'         title',
'         office_name',
'         mls_logo',
'         mls_disclaimer',
'         idx_type',
'         back_office_type',
'         last_idx',
'         last_clean',
'         last_bo',
'         created_at',
'         updated_at',
'         deleted_at',
        ],
        wheres: {
          status: '',
        },
        whereins: {
          website: [],
          idx_type: [],
          back_office_type: [],
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }
    
    this.default_new_mls.website = this.website_id;
    this.new_mls = JSON.parse(JSON.stringify(this.default_new_mls));

    this.setWhereIns('idx_types','filters','idx_type');
    this.setWhereIns('back_office_types','filters','back_office_type');

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/mlss/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_mls() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/mlss/store', this.new_mls).then(res => {
        // console.log(res);
        this.new_mls = JSON.parse(JSON.stringify(this.default_new_mls));
        this.$refs.modal_add_mls.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <button type="button" @click="new_mls = JSON.parse(JSON.stringify(default_new_mls)); $refs.modal_add_mls.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_mls" centered size="xl" title="Create a new MLS" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <b-form @submit.prevent="add_mls">
              <div class="p-4">
                <MlssForm :item="new_mls"></MlssForm>
              </div>
              <footer class="modal-footer">
                <button type="button" class="btn btn-light" @click="$refs.modal_add_mls.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
                <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
              </footer>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.status" :Options="status_list" placeholder="Filter by live..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            IDX types: ({{idx_types.filter(b=>{return b.active}).length}}/{{idx_types.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in idx_types" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('idx_types','filters','idx_type'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Back office types: ({{back_office_types.filter(b=>{return b.active}).length}}/{{back_office_types.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in back_office_types" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('back_office_types','filters','back_office_type'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead>
              <tr>
                <th><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Office name" :orderby.sync="filters.orderbys.office_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Live" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="IDX type" :orderby.sync="filters.orderbys.idx_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Back office type" :orderby.sync="filters.orderbys.back_office_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last IDX" :orderby.sync="filters.orderbys.last_idx" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last clean" :orderby.sync="filters.orderbys.last_clean" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last back office" :orderby.sync="filters.orderbys.last_bo" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Office name" :orderby.sync="filters.orderbys.office_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Live" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="IDX type" :orderby.sync="filters.orderbys.idx_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Back office type" :orderby.sync="filters.orderbys.back_office_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last IDX" :orderby.sync="filters.orderbys.last_idx" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last clean" :orderby.sync="filters.orderbys.last_clean" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last back office" :orderby.sync="filters.orderbys.last_bo" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/mlss/'+item.id" tag="tr" class="_c-pointer" exact>
                <td><router-link :to="'/mlss/'+item.id" class="text-inherit text-hover-inherit"><div class="text-dark font-weight-bold">{{item.title}}</div></router-link></td>
                <td><router-link :to="'/mlss/'+item.id" class="text-inherit text-hover-inherit">{{item.office_name}}</router-link></td>
                <td><router-link :to="'/mlss/'+item.id" class="text-inherit text-hover-inherit">{{item.website}}</router-link></td>
                <td><div v-if="item.status" class="alert alert-success mb-0">Yes</div><div v-else class="alert alert-danger mb-0">No</div></td>
                <td class="py-1"><div class="alert m-0" :class="item.idx_type != 'None' ? 'alert-success' : 'alert-danger'">{{item.idx_type}}</div></td>
                <td class="py-1"><div class="alert m-0" :class="item.back_office_type != 'None' ? 'alert-success' : 'alert-danger'">{{item.back_office_type}}</div></td>
                <td v-tippy :content="moment.utc(item.last_idx).local().format('lll')">{{moment.utc(item.last_idx).local().format('lll')}}</td>
                <td v-tippy :content="moment.utc(item.last_clean).local().format('lll')">{{moment.utc(item.last_clean).local().format('lll')}}</td>
                <td v-tippy :content="moment.utc(item.last_bo).local().format('lll')">{{moment.utc(item.last_bo).local().format('lll')}}</td>
                <td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td>
                <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

